<template>
  <Footer :columns="columns">
    <FooterOfficeInformation />
  </Footer>
</template>

<script>
import Footer from 'chimera/all/themes/blueflow/components/layout/Footer'
import FooterOfficeInformation from 'chimera/all/themes/blueflow/components/layout/FooterOfficeInformation'

export default {
  components: {
    Footer,
    FooterOfficeInformation,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      columns: [
        {
          title: 'À propos de nous',
          links: [
            {
              text: 'Contact',
              to: '/contact',
            },
          ],
        },
        {
          title: 'Professionnels',
          links: [
            {
              text: 'Inscrivez-vous en tant que Pro',
              to: '/contact-entreprise',
            },
          ],
        },
      ],
    }
  },
}
</script>
